// extracted by mini-css-extract-plugin
export default {"root":"EventCardPromoCodeLabel-module__root___BxRo3","label":"EventCardPromoCodeLabel-module__label___1o7jo"};